<div class="container-flud cont">
  <wellro-spinner strokeWidth="3" color="#24da54"></wellro-spinner>
</div>
